import type { LayoutLoad } from './$types';
import { loadStaticConfig } from '#lib/config.js';

export const load: LayoutLoad = async ({ fetch }) => {
	const config = await loadStaticConfig(fetch);
	return { config };
};
